const IconCollapse = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 17.8H14.2V22H15.4V16.6H10V17.8ZM17.8 10H16.6V15.4H22V14.2H17.8V10Z"
      fill={props?.fill || "#BBC4E0"}
    />
  </svg>
);

export default IconCollapse;
